import { FC, useState } from 'react'
import { Button } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { getTrace } from 'lib/queries/useGetSignedTrace/trace'
import { TraceRequest } from 'lib/queries/useGetSignedTrace/trace.types'

interface TraceDownloaderProps {
  traceRequest: TraceRequest
}

const TraceDownloader: FC<TraceDownloaderProps> = ({ traceRequest }) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleDownload = async (): Promise<void> => {
    try {
      setIsLoading(true)

      const { signedUrl } = await getTrace(traceRequest)

      const link = document.createElement('a')
      link.href = signedUrl
      link.download = traceRequest.traceFile
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
      <Button
        type="primary"
        icon={<DownloadOutlined />}
        onClick={handleDownload}
        loading={isLoading}
        disabled={isLoading}
      >
        Download Trace
      </Button>
    </div>
  )
}

export default TraceDownloader
